import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Contact = ({ size = 'large' }) => {
  const theme = useTheme();

  return <ContactSupportIcon fontSize={size} sx={tertiaryHoverSx(theme)} />;
};
